import { Box, ContentLoader } from "@bca/ui-library";
import React from "react";

const SortLoader = () => {
  return (
    <Box
      key="index"
      display="flex"
      justifyContent="flex-end"
      alignSelf="center"
      paddingX="0"
      paddingBottom={{
        mobile: 5,
        tablet: 5,
        desktop: "0",
      }}
      paddingTop={{
        mobile: "48px",
        tablet: "48px",
        desktop: "0",
      }}
    >
      <ContentLoader width="158px" height="18px">
        <rect width="19px" height="19px" rx={4} ry={4}></rect>
        <rect width="134px" height="19px" x="24px" rx={4} ry={4}></rect>
      </ContentLoader>
    </Box>
  );
};

export default SortLoader;
